import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../config/axiosInterceptor";
import { CreateDealType, SubmitEstimateType } from "./types";
import { RcFile } from "antd/es/upload";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const createPotentialDeal = (
  payload: CreateDealType
): Promise<AxiosResponse<CreateDealType>> => {
  return axios.post(`${baseURL}createPotentialDeal`, payload);
};

export const deletePotentialDeal = (
  dealIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deletePotentialDeal`, { data: dealIds });
};

export const changePotentialDealStatus = (
  id: string,
  payload: {
    status: string;
  }
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}changePotentialDealStatus/${id}`, payload);
};

export const updatePotentialDealById = (
  id: string,
  payload: CreateDealType
): Promise<AxiosResponse<CreateDealType>> => {
  return axios.patch(`${baseURL}updatePotentialDealById/${id}`, payload);
};

export const saveProposal = (
  payload: SubmitEstimateType
): Promise<AxiosResponse<SubmitEstimateType>> => {
  return axios.post(`${baseURL}saveProposal`, payload);
};

export const deleteProposalById = (
  id: string
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteProposalById/${id}`);
};

export const updateProposalById = (
  id: string,
  payload: { summary: string }
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}updateProposalById/${id}`, payload);
};

export const changeProposalStatus = (
  payload: { status: string; deal_id: string },
  id: string
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}changeProposalStatus/${id}`, payload);
};

export const makeDealAsCopied = (
  id: string
): Promise<AxiosResponse<string>> => {
  return axios.get(`${baseURL}makeDealCopy/${id}`);
};

// export const sentProposalDoc = (payload: {
//   proposal_id: string;
// }): Promise<AxiosResponse<string>> => {
//   return axios.post(`${baseURL}sentProposalDoc`, payload);
// };

export const saveProposalBuilder = (payload: {
  proposal_id: string;
  deal_id: string;
  company_id: string;
  document: string;
  proposal_name: string;
  complete_html: string;
}): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}saveProposalBuilder`, payload);
};

export const docSigning = async ({
  owner_id,
  image,
  // company_id,
  // deal_id,
  accepted_by_name,
  accepted_by_email,
  accepted_by_title,
}: {
  owner_id: string;
  image: RcFile | File;
  // company_id: string;
  // deal_id: string;
  accepted_by_name: string;
  accepted_by_email: string;
  accepted_by_title: string;
}): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("owner_id", owner_id);
  formData.append("image", image);
  formData.append("image_type", "proposal_document_image");
  // formData.append("company_id", company_id);
  // formData.append("deal_id", deal_id);
  formData.append("accepted_by_name", accepted_by_name);
  formData.append("accepted_by_email", accepted_by_email);
  formData.append("accepted_by_title", accepted_by_title);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`${baseURL}docSigning`, formData, config);
};

export const askForRevision = (payload: {
  proposal_id: string;
  proposal_doc_id: string;
  // company_id: string;
  comments: string;
  first_name: string;
  last_name: string;
}): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}askForRevision`, payload);
};

export const sentProposalDoc = (payload: {
  proposal_id: string;
  company_id: string;
  emails: string[];
  subject: string;
  client_contact: {
    first_name: string;
    last_name: string;
    title: string;
    email: string;
    phone: string;
  };
  html: string;
  status: string;
  expiry_date?: string;
}): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}sentProposalDoc`, payload);
};

export const sendProposalToProduction = (payload: {
  potential_deal_id: string;
  proposal_id: string;
  manager_id: string;
  service_lines: {
    service_line_id: string;
    production_manager_id: string;
    crew_id: string;
  }[];
  start_date: string;
  end_date: string;
  renewable: boolean;
  pricing_model: string;
  billing: string;
  net_terms: string;
}): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}sendProposalToProduction`, payload);
};

export const sendChangeOrderToProduction = (payload: {
  potential_deal_id: string;
  proposal_id: string;
  manager_id: string;
  service_lines: {
    service_line_id: string;
    production_manager_id: string;
    crew_id: string;
  }[];
  start_date: string;
  end_date: string;
  renewable: boolean;
  pricing_model: string;
  billing: string;
  net_terms: string;
  contract_id: string;
}): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}sendChangeOrderToProduction`, payload);
};

export const makeProposalAsCopied = (
  id: string
): Promise<AxiosResponse<string>> => {
  return axios.get(`${baseURL}makeProposalCopy/${id}`);
};
